// @flow

export function isConcurrencyError(error: string): boolean {
  switch (error) {
    case 'CI-005':
      return true;
    default:
      return false;
  }
}
